module.exports = __webpack_public_path__ + "static/zama-6-807a3f0b4146643b1699a3bc8e8fd7e0.gif";